import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormsService} from "../../../services/forms.service";
import {PopupService} from "../../../services/popup.service";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { UserService } from "../../../services/user.service";
import { AuthService } from "../../../services/auth.service";
import { submitUserProfile, skipSetup } from "../../../state/userProfile/userProfile.actions";
import {
  selectSetupError,
  selectSetupMessage,
  selectUserProfileSuccess,
  selectUserProfileError,
  selectUpdateUserProfileSuccess, selectUpdateUserProfileError
} from "../../../state/userProfile/userProfile.selectors";
import {Store} from "@ngrx/store";
import {AppState} from "../../../state/app.state";
import {filter, Subscription, take} from "rxjs";
import {updateUser} from "../../../state/auth/auth.actions";
import {loadProfileLists} from "../../../state/profileList/profileList.actions";
import {selectProfileListsFailure, selectProfileListsSuccess} from "../../../state/profileList/profileList.selectors";
import {loadCountries} from "../../../state/list/list.actions";
import {selectCountriesFailure, selectCountriesSuccess} from "../../../state/list/list.selectors";

@Component({
  selector: 'app-account-setup',
  templateUrl: './account-setup.component.html',
  styleUrls: ['./account-setup.component.scss']
})
export class AccountSetupComponent implements OnInit, OnDestroy  {

  form: FormGroup;
  errorMessages: any;
  isLoading: boolean = false;

  user: any;

  successMessage?: string;
  errorMessage?: string;
  private subscriptions = new Subscription();

  step: number = 1;

  profileLists: any[] = [];
  actualDuties: any[] = [];
  companySizes: any[] = [];
  customerCompanySizes: any[] = [];
  companyRevenues: Record<string, any>[] = []; // any[] = [];
  industries: any[] = [];
  customerIndustries: any[] = [];
  buyingCycles: any[] = [];
  trendEmployees: any[] = [];
  trendRevenues: any[] = [];
  closedDeals: any[] = [];
  countries: any[] = [];

  hasUserProfile: boolean = true;

  private successSubscription: Subscription;
  private failureSubscription: Subscription;

  constructor(
    private formService: FormsService,
    private popupService: PopupService,
    private routerService: Router,
    public formBuilder: FormBuilder,
    private userService: UserService,
    private authService: AuthService,
    private store: Store<AppState>,
    private router: Router,
  ) {

    this.form = formBuilder.group({
      linkedin_url: ["", [Validators.required, Validators.pattern(/^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/), Validators.maxLength(255)]],
      job_title: ["", [Validators.required, Validators.maxLength(255)]],
      actual_duty_id: ["", [Validators.required]],
      // what_i_actually_do: ["", [Validators.required, Validators.maxLength(255)]],
      company_size_id: ["", [Validators.required]],
      industry_ids: [[], [Validators.required]],
      what_is_my_main_challenge: ["", [Validators.maxLength(255)]],
      what_solutions_do_i_sell: ["", [Validators.maxLength(255)]],
      how_i_help_my_customers: ["", [Validators.maxLength(255)]],
      min_value_sold: ["", [Validators.maxLength(20)]],
      max_value_sold: ["", [Validators.maxLength(20)]],
      further_developments: ["", [Validators.maxLength(255)]],

      // Step 2
      customer_company_size_ids: [[], [Validators.required]],
      company_revenue_ids: [[], [Validators.required]],
      customer_industry_ids: [[], [Validators.required]],
      challenges_solved: ["", [Validators.required, Validators.maxLength(255)]],
      buying_cycle_id: [1, [Validators.required]],
      company_profitability: ["", Validators.maxLength(255)],
      location_numbers: ["", Validators.maxLength(255)],
      target_country_ids: [[]],
      trend_employee_id: [1, [Validators.required]],
      trend_revenue_id: [1, [Validators.required]],
      other_criteria: ["", Validators.maxLength(255)],
      open_jobs: ["", Validators.maxLength(255)],

      // Step 3
      main_user_department_role: ["", [Validators.required, Validators.maxLength(255)]],
      main_user_role: ["", [Validators.required, Validators.maxLength(255)]],
      main_buyer_department: ["", [Validators.required, Validators.maxLength(255)]],
      main_buyer_job_title: ["", [Validators.required, Validators.maxLength(255)]],
      close_deal_id: [1, [Validators.required]],
      other_departments: ["", Validators.maxLength(255)],
      other_people: ["", Validators.maxLength(255)],
      country_exclusion_ids: [[]],
    });

    this.errorMessages = {
      // Step 1
      linkedin_url: [{type: "required",  message: "LinkedIn URL is required"}, {type: "maxlength", message: "LinkedIn URL cannot exceed 255 characters"}],
      job_title: [{type: "required",  message: "Job title is required"}, {type: "maxlength", message: "Job title cannot exceed 255 characters"}],
      actual_duty_id: [{type: "required",  message: "What I do is required"}],
      // what_i_actually_do: [{type: "required",  message: "What I do is required"}, {type: "maxlength", message: "What I do cannot exceed 255 characters"}],
      company_size_id: [{type: "required",  message: "Company size is required"}],
      industry_ids: [{type: "required",  message: "Industry is required"}],
      what_is_my_main_challenge: [{type: "maxlength", message: "What is my main challenge cannot exceed 255 characters"}],
      what_solutions_do_i_sell: [{type: "required", message: "What solutions do I sell cannot exceed 255 characters"}],
      how_i_help_my_customers: [{type: "maxlength", message: "Help customers cannot exceed 255 characters"}],
      min_value_sold: [{type: "maxlength", message: "Minimum value sold cannot exceed 20 characters"}],
      max_value_sold: [{type: "maxlength", message: "Maximum value sold cannot exceed 20 characters"}],
      further_developments: [{type: "maxlength", message: "Further developments cannot exceed 255 characters"}],

      // Step 2
      customer_company_size_ids: [{type: "required",  message: "Company size is required"}],
      company_revenue_ids: [{type: "required",  message: "Company revenue is required"}],
      customer_industry_ids: [{type: "required",  message: "Industry is required"}],
      challenges_solved: [{type: "required",  message: "Challenges solved is required"}, {type: "maxlength", message: "What I do cannot exceed 255 characters"}],
      buying_cycle_id: [{type: "required",  message: "Buying cycle is required"}],
      company_profitability: [{type: "maxlength", message: "Company profitability cannot exceed 255 characters"}],
      location_numbers: [{type: "maxlength", message: "Location numbers cannot exceed 255 characters"}],
      target_country_ids: [{type: "maxlength", message: "Target countries cannot exceed 255 characters"}],
      trend_employee_id: [{type: "required",  message: "Trend employee is required"}],
      trend_revenue_id:  [{type: "required",  message: "Trend revenue is required"}],
      other_criteria: [{type: "maxlength", message: "Other criteria cannot exceed 255 characters"}],
      open_jobs: [{type: "maxlength", message: "Open jobs cannot exceed 255 characters"}],

      // Step 3
      main_user_department_role: [{type: "required",  message: "Main user department role is required"}, {type: "maxlength", message: "What I do cannot exceed 255 characters"}],
      main_user_role: [{type: "required",  message: "Main user role is required"}, {type: "maxlength", message: "What I do cannot exceed 255 characters"}],
      main_buyer_department: [{type: "required",  message: "Main buyer department is required"}, {type: "maxlength", message: "What I do cannot exceed 255 characters"}],
      main_buyer_job_title: [{type: "required",  message: "Main buyer job title is required"}, {type: "maxlength", message: "What I do cannot exceed 255 characters"}],
      close_deal_id: [{type: "required",  message: "Close deal is required"}],
      other_departments: [{type: "maxlength", message: "Other departments cannot exceed 255 characters"}],
      other_people: [{type: "maxlength", message: "Other people cannot exceed 255 characters"}],
      country_exclusion_ids: [{type: "maxlength", message: "Country exclusion cannot exceed 255 characters"}],
    };

  }

  handleIndustrySelectionChange(selectedIndustries: any[]): void {
    // console.log('Selected industries:', selectedIndustries);

    const selectedIndustryIds = selectedIndustries.map(industry => industry.id);
    this.form.patchValue({ industry_ids: selectedIndustryIds });
  }

  handleCustomerIndustrySelectionChange(selectedCustomerIndustries: any[]): void {
    // console.log('Selected customer industries:', selectedCustomerIndustries);

    const selectedCustomerIndustryIds = selectedCustomerIndustries.map(industry => industry.id);
    this.form.patchValue({ customer_industry_ids: selectedCustomerIndustryIds });
  }

  handleCustomerCompanySizeSelectionChange(selectedCustomerCompanySizes: any[]): void {
    // console.log('Selected customer company sizes:', selectedCustomerCompanySizes);

    const selectedCustomerCompanySizeIds = selectedCustomerCompanySizes.map(customerCompanySize => customerCompanySize.id);
    this.form.patchValue({ customer_company_size_ids: selectedCustomerCompanySizeIds });
  }

  handleCompanyRevenueSelectionChange(selectedCompanyRevenues: any[]): void {
    // console.log('Selected company revenues:', selectedCompanyRevenues);

    const selectedCompanyRevenueIds = selectedCompanyRevenues.map(companyRevenue => companyRevenue.id);
    this.form.patchValue({ company_revenue_ids: selectedCompanyRevenueIds });
  }

  handleTargetCountrySelectionChange(selectedTargetCountries: any[]): void {
    // console.log('Selected target countries:', selectedTargetCountries);

    const selectedTargetCountryIds = selectedTargetCountries.map(country => country.id);
    this.form.patchValue({ target_country_ids: selectedTargetCountryIds });
  }

  handleCountryExclusionListSelectionChange(selectedCountryExclusionList: any[]): void {
    // console.log('Selected country exclusion list:', selectedCountryExclusionList);

    const selectedCountryExclusionIds = selectedCountryExclusionList.map(country => country.id);
    this.form.patchValue({ country_exclusion_ids: selectedCountryExclusionIds });
  }

  ngOnInit(): void {

    this.authService.authUser().subscribe(user => {
      this.user = user;

      // Redirect if setup is already complete
      if (this.user.has_completed_setup === 1) {
        // this.router.navigate(['/dashboard']);
      }
    });

    // Prepopulate LinkedIn URL if available
    this.form.patchValue({
      linkedin_url: this.user.linkedin_url || ""
    });

    this.subscriptions.add(this.store.select(selectUserProfileSuccess).subscribe(data => {
      if (data) {

        this.successMessage = 'Profile update successful!';
        console.log('Profile update successful:', data);

        this.authService.authUser().subscribe(user => {
          this.user = user;

          // Ensure that we only update if necessary
          if (this.user.has_completed_setup !== 1) {

            const updatedUser = {...this.user, has_completed_setup: 1};
            this.store.dispatch(updateUser({ user: updatedUser }));
          }

          this.popupService.notify('Your profile has been successfully stored.', 'Profile Store Successful', 'success');
          // this.router.navigate(['/dashboard']);
          this.errorMessage = '';
        });

      }
    }));

    this.subscriptions.add(this.store.select(selectUserProfileError).subscribe(error => {
      if (error) {
        this.errorMessage = 'Failed to store profile. Error: ' + error;
        console.error('Profile store failed:', error);
        this.popupService.notify(error.error.message, 'Profile Store Failed', 'error');
        // Reset success message if previously set
        this.successMessage = '';
      }
    }));

    this.getProfileLists()
    this.getCountries()

  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();

    this.successSubscription.unsubscribe();
    this.failureSubscription.unsubscribe();
  }

  submitForm() {

    if (this.isStepValid(this.step)) {

      if (this.form.valid) {

        /*
        const profileData = {
          name: 'ACCOUNT_SETUP',
          data: {}
        };
        */

        const profileData = {
          user_id: Number(this.user.id),
          linkedin_url: this.user.linkedin_url ? this.user.linkedin_url : this.form.value.linkedin_url,
          job_title: this.form.value.job_title,
          actual_duty_id: this.form.value.actual_duty_id,
          // what_i_actually_do: this.form.value.what_i_actually_do,
          company_size_id: this.form.value.company_size_id,
          industry_ids: this.form.value.industry_ids,
          what_is_my_main_challenge: this.form.value.what_is_my_main_challenge ? this.form.value.what_is_my_main_challenge : '-',
          what_solutions_do_i_sell: this.form.value.what_solutions_do_i_sell ? this.form.value.what_solutions_do_i_sell : '-',
          how_i_help_my_customers: this.form.value.how_i_help_my_customers ? this.form.value.how_i_help_my_customers : '-',
          min_value_sold: this.form.value.min_value_sold ? this.form.value.min_value_sold : 0,
          max_value_sold: this.form.value.max_value_sold ? this.form.value.max_value_sold : 0,
          further_developments: this.form.value.further_developments ? this.form.value.further_developments : '-',

          customer_company_size_ids: this.form.value.customer_company_size_ids,
          company_revenue_ids: this.form.value.company_revenue_ids,
          customer_industry_ids: this.form.value.customer_industry_ids,
          challenges_solved: this.form.value.challenges_solved,
          buying_cycle_id: this.form.value.buying_cycle_id,
          company_profitability: this.form.value.company_profitability,
          location_numbers: this.form.value.location_numbers,
          target_country_ids: this.form.value.target_country_ids,
          trend_employee_id: this.form.value.trend_employee_id,
          trend_revenue_id: this.form.value.trend_revenue_id,
          other_criteria: this.form.value.other_criteria,
          open_jobs: this.form.value.open_jobs,

          main_user_department_role: this.form.value.main_user_department_role,
          main_user_role: this.form.value.main_user_role,
          main_buyer_department: this.form.value.main_buyer_department,
          main_buyer_job_title: this.form.value.main_buyer_job_title,
          close_deal_id: this.form.value.close_deal_id,
          other_departments: this.form.value.other_departments,
          other_people: this.form.value.other_people,
          country_exclusion_ids: this.form.value.country_exclusion_ids,
        }

        this.store.dispatch(submitUserProfile({profileData: profileData}));

        this.subscriptions.add(
          this.store.select(selectUpdateUserProfileSuccess).subscribe(data => {
            if (data) {

              const updatedUser = {...this.user, linkedin_url: this.user.linkedin_url ? this.user.linkedin_url : this.form.value.linkedin_url};
              this.store.dispatch(updateUser({ user: updatedUser }));

              this.popupService.notify('Your profile has been successfully updated.', 'Profile Update Successful', 'success');
              this.step = 1;

            }
          })
        );

        this.subscriptions.add(
          this.store.select(selectUpdateUserProfileError).subscribe(error => {
            if (error) {

              if (error.error.message === 'User profile not found !') {
                this.hasUserProfile = false
              }

              console.log('Fetch UserProfile Failure:', error);
            }
          })
        );

      }

    } else {
      this.markFieldsAsTouched(this.step);
    }

    /*
    this.form.markAllAsTouched();

    if (this.form.valid) { }
    */
  }

  /*
  skipSetup() {

    this.store.dispatch(skipSetup());

    this.store.select(selectSetupMessage).subscribe(message => {
      if (message) {
        console.log('Setup skipped:', message);

        const updatedUser = {...this.user, has_completed_setup: 1};
        this.store.dispatch(updateUser({ user: updatedUser }));

        this.popupService.notify(message, 'Skip Setup Successful', 'success');
        this.router.navigate(['/dashboard']);

      }
    });

    this.store.select(selectSetupError).subscribe(error => {
      if (error) {
        console.error('Failed to skip setup:', error);
        this.popupService.notify(error.message, 'Skip Setup Failed', 'error');
      }
    });

  }
  */

  /*
  changeStep(nextStep: number): void {
    if (this.isStepValid(this.step)) {
      this.step = nextStep;
    } else {
      this.markFieldsAsTouched(this.step);
    }
  }
  */

  changeStep(nextStep: number): void {
    if (nextStep > this.step) {
      // Moving forward, check if the current step is valid
      if (this.isStepValid(this.step)) {
        this.step = nextStep;
      } else {
        this.markFieldsAsTouched(this.step);
      }
    } else {
      // Moving backward, don't validate, just allow navigation
      this.step = nextStep;
    }
  }

  isStepValid(step: number): boolean {
    if (step === 1) {

      console.log('')

      return (this.form.get('linkedin_url').disabled || this.form.get('linkedin_url').valid) &&
        this.form.get('job_title').valid &&
        this.form.get('actual_duty_id').valid &&
        // this.form.get('what_i_actually_do').valid &&
        this.form.get('company_size_id').valid &&
        this.form.get('industry_ids').valid &&
      // this.form.get('what_is_my_main_challenge').valid &&
      this.form.get('what_solutions_do_i_sell').valid
      // this.form.get('how_i_help_my_customers').valid &&
      // this.form.get('min_value_sold').valid &&
      // this.form.get('max_value_sold').valid &&
      // this.form.get('further_developments').valid;
    } else if (step === 2) {
      return this.form.get('customer_company_size_ids').valid &&
        this.form.get('company_revenue_ids').valid &&
        this.form.get('customer_industry_ids').valid &&
        this.form.get('challenges_solved').valid &&
        this.form.get('buying_cycle_id').valid &&
        this.form.get('trend_employee_id').valid &&
        this.form.get('trend_revenue_id').valid &&
        this.form.get('main_user_role').valid &&
        this.form.get('main_buyer_department').valid &&
        this.form.get('main_buyer_job_title').valid &&
        this.form.get('close_deal_id').valid;
    }
    return false;
  }

  markFieldsAsTouched(step: number): void {
    if (step === 1) {
      if (this.form.get('linkedin_url') && this.form.get('linkedin_url').enabled) {
        this.form.get('linkedin_url').markAsTouched();
      }
      this.form.get('job_title').markAsTouched();
      this.form.get('actual_duty_id').markAsTouched();
      // this.form.get('what_i_actually_do').markAsTouched();
      this.form.get('company_size_id').markAsTouched();
      this.form.get('industry_ids').markAsTouched();
      // this.form.get('what_is_my_main_challenge').markAsTouched();
      this.form.get('what_solutions_do_i_sell').markAsTouched();
      // this.form.get('how_i_help_my_customers').markAsTouched();
      // this.form.get('min_value_sold').markAsTouched();
      // this.form.get('max_value_sold').markAsTouched();
      // this.form.get('further_developments').markAsTouched();
    } else if (step === 2) {
      this.form.get('customer_company_size_ids').markAsTouched();
      this.form.get('company_revenue_ids').markAsTouched();
      this.form.get('customer_industry_ids').markAsTouched();
      this.form.get('challenges_solved').markAsTouched();
      this.form.get('buying_cycle_id').markAsTouched();
      this.form.get('trend_employee_id').markAsTouched();
      this.form.get('trend_revenue_id').markAsTouched();
      this.form.get('main_user_department_role').markAsTouched();
      this.form.get('main_user_role').markAsTouched();
      this.form.get('main_buyer_department').markAsTouched();
      this.form.get('main_buyer_job_title').markAsTouched();
      this.form.get('close_deal_id').markAsTouched();
    }
  }

  getProfileLists() {
    this.store.dispatch(loadProfileLists());

    // Ensure subscriptions are set up after dispatching
    this.successSubscription = this.store.select(selectProfileListsSuccess).pipe(
      filter(response => response !== null), // ensure there's data
    ).subscribe({
      next: (response) => {
        // console.log('Profile lists loaded successfully', response);
        this.profileLists = response.profileLists

        this.actualDuties = response.profileLists.actual_duties
        this.companySizes = response.profileLists.company_sizes
        this.customerCompanySizes = response.profileLists.customer_company_size
        this.companyRevenues =  response.profileLists.company_revenues
        this.industries = response.profileLists.industry
        this.customerIndustries = response.profileLists.customer_industry
        this.buyingCycles = response.profileLists.buying_cycle
        this.trendEmployees = response.profileLists.trend_employee
        this.trendRevenues = response.profileLists.trend_revenue
        this.closedDeals = response.profileLists.close_deal
      },
      error: (error) => {
        console.error('Profile lists loading success handler error:', error);
      }
    });

    this.failureSubscription = this.store.select(selectProfileListsFailure).pipe(
      filter(error => error !== null),
    ).subscribe({
      next: (error) => {
        console.error('Failed to load profile lists:', error.message);
      },
      error: (error) => {
        console.error('Profile lists loading failure handler error:', error);
      }
    });

  }

  getCountries() {
    this.store.dispatch(loadCountries());

    // Ensure subscriptions are set up after dispatching
    this.successSubscription = this.store.select(selectCountriesSuccess).pipe(
      filter(response => response !== null), // ensure there's data
    ).subscribe({
      next: (response) => {
        // console.log('Countries loaded successfully', response);
        this.countries = response.countries
      },
      error: (error) => {
        console.error('Countries loading success handler error:', error);
      }
    });

    this.failureSubscription = this.store.select(selectCountriesFailure).pipe(
      filter(error => error !== null),
    ).subscribe({
      next: (error) => {
        console.error('Failed to load countries:', error.message);
      },
      error: (error) => {
        console.error('Countries loading failure handler error:', error);
      }
    });

  }

}
